import {ComboBox} from "../../comboBox/ComboBox.jsx";
import {useCompanyContacts} from "./KeyAccountsApproval.hooks.jsx";

export const ApprovedByComboBox = ({retailerSfid, onChange, statusAssignee}) => {
  const contacts = useCompanyContacts(retailerSfid);
  const statusUpdate =  statusAssignee === 'Approver' ? 'Approved' : 'Denied'

  return <ComboBox
      testId={`${statusUpdate.toLowerCase()}-by-combobox-${retailerSfid}`}
      label={`${statusUpdate} by (${retailerSfid})`}
      data={contacts}
      isMultiple={false}
      disableCloseOnSelect={false}
      onChange={onChange}
  />
}